import { getStaticDocUrl } from "../utils/staticDocumentUrls"
import React from "react"

export var pt_PT = {
  Retry: "Tentar novamente",
  Continue: "Continuar",
  "Secure payment": "Pagamento seguro",
  "Payment validation": "Validação do pagamento",
  "Validation de votre paiement en cours": "A validação do seu pagamento está em curso",
  "Complete your payment with Aplazame.": "Conclua o seu pagamento com a Aplazame.",
  AplazameConfirmation: "Confirmation",
  "Complete your secure payment below.": "Conclua abaixo o seu pagamento seguro.",
  "Initializing secure payment...": "A iniciar o pagamento seguro...",
  "Unable to load payment configuration. Please try again.":
    "Nao foi possivel carregar a configuracao do pagamento. Tente novamente.",
  "Unable to start payment. Please try again.": "Nao foi possivel iniciar o pagamento. Tente novamente.",
  "Unable to submit payment. Please try again.": "Nao foi possivel enviar o pagamento. Tente novamente.",
  "A problem occurred during finalization. You will be redirected shortly.":
    "Ocorreu um problema durante a finalizacao. Sera redirecionado em breve.",
  "Retry failed. Please try again.": "A nova tentativa falhou. Tente novamente.",
  "Payment initialization is taking longer than expected. Please try again or contact support.":
    "A inicializacao do pagamento esta a demorar mais do que o esperado. Tente novamente ou contacte o suporte.",
  Finalization: "Finalizacao",
  "Bank card": "Cartao bancario",
  "Photo of your ID": "Fotografia do seu documento de identificacao",
  "Your photo": "A sua fotografia",
  /* ========================================== */
  /* COMMON =================================== */
  /* ========================================== */
  "Back to shop": "Voltar para a loja",
  "Redirecting to Samsung shop shortly": "Irá ser redirecionado para a Samsung Shop num instante.",
  button_back_shop: "Voltar à loja",
  button_back_to_my_basket: "Voltar ao meu carrinho",
  Back: "Voltar",
  Validate: "Validar",
  civility_mr: "Sr.",
  civility_mrs: "Sra.",
  "Your transaction is being finalized.": "A sua transação está a ser concluída.",
  button_cancel: "Annular",
  button_close: "Fechar",
  button_send_upload: "Carregar documentos",
  Submit_BPLS: "Submeter o meu pedido",
  "Select...": "Selecionar",
  ACKNOWLEDGMENT_RECEIPT: "Accusé de réception",
  OTHER: "Outro",
  DIAGNOSTIC_ASSESSMENT: "Diagnóstico Bilan",
  DELIVERY_FORM: "Formulário de entrega do produto",
  RETURN_FORM: "Bon de restituição",
  WITHDRAWAL_FORM: "Bordereau de retratação",
  COURIER: "Correio",
  DISTRIBUTOR_INVOICE: "Fatura do distribuidor",
  ADDRESS_PROOF: "Justificativa de domicílio",
  EXTERNAL_PAYMENT_PROOF: "Justificativa de pagamento externo",
  SEPA_MANDATE: "Mandato SEPA",
  Choose: "Escolher",
  Start: "Começar",
  modifier_donnees: "Mofifique os seus dados",
  bpls_onboarding_validation_button: "Complete as suas informações",
  "thanks you for your request.": "agradece o seu pedido",
  /* ========================================== */
  /* BREADCRUMB =============================== */
  /* ========================================== */
  Services: "Serviços",
  Informations: "Informações",
  "My informations": "Minha informação",
  Summary: "Sumário",
  "My summary": "Meu sumário",
  Contracts: "Contratos",
  "Back to basket": "Regressar ao carrinho",
  /* ========================================== */
  /* BASKET =================================== */
  /* ========================================== */
  Basket: "Carrinho",
  Ma_demande_location: "O meu pedido de locação",
  Accessories: "Acessório(s)",
  "Promo code": "Código promocional",
  on: "sobre",
  months: "meses",
  Included: "Incluído",
  Offered: "oferecidos",
  "Shipping fees": "Taxas de envio",
  Upfront: "Primeiro pagamento",
  "My upfront": "Meu primeiro pagamento",
  Rent: "Prestação",
  "/month": "/mês",
  months_uppercase: " Meses",
  YYYY: "AAAA",
  "YYYY/MM/DD": "DD/MM/AAAA",
  "DD/MM/YYYY": "DD/MM/AAAA",
  "including services pack at": "incluindo pacote de serviços em",
  "including services at": "incluindo pacote de serviços em",
  obligatorystar: "*",
  "including insurance at": "incluindo seguro a",
  renouvellementProduit: "Renovação do produto",
  "Supporting documents requested": "Documentos comprovativos solicitados",
  "A bank card in your name": "Cartão bancário em seu nome",
  "Your mobile phone": "O seu número de telemóvel",
  "A bank identity statement in your name": "Um comprovativo de NIB/IBAN",
  "My RIB": "Um comprovativo de Iban",
  "Your banking credentials": "As suas credenciais bancárias (para recuperar o seu extracto bancário)",
  "Mon relevé bancaire": "O meu extracto bancário",
  "A valid ID in your name": "Um documento de identificação válido em seu nome",
  "My ID": "Meu comprovativo de identidade",
  "My valid ID": "Um documento comprovativo de identidade que esteja válido",
  bpls_onboarding_id: "Documento de identificação",
  bpls_onboarding_company_rib: "Iban da sua empresa",
  "Proof of address of less than 3 months": "Comprovativo de morada com menos de 3 meses",
  "Proof of address of less than 6 months": "Comprovativo de morada com menos de 6 meses",
  "A mobile phone bill less than 6 months old in your name": "Une facture de téléphonie mobile de moins de 6 mois",
  "Uma factura de telemóvel com menos de 6 meses":
    "Factura de energia, telefone ou internet em seu nome com menos de 6 meses",
  "My proof of amount income": "O meu justificativo de salário",
  "My proof of address": "Meu comprovativo de morada",
  /* ========================================== */
  /* ONBOARDING PAGE ========================== */
  /* ========================================== */
  "Then i finalize my order in shop under 5 days, bringing with me those 4 proofs":
    "Depois eu finalizo em loja o meu pedido de locação até um máximo de 5 dias, levando comigo os 4 documentos justificativos seguintes:",
  "My identification": "A minha identificação",
  "Only if your bancary document's address is different than the one you will enter":
    "Unicamente se a morada do seu documento bancário for diferente da sua morada que vai introduzir",
  "Only if my RIB's address is different from my current address":
    "Unicamente se a morada do seu IBAN for diferente da sua morada actual",
  "Enter the informations that will allow us to identify you.": "Insira as informações que nos permitam identificá-lo.",
  "Start your location online then meet us in our sellpoint.":
    "Começe o seu pedido de subscrição online e venha ter connosco em loja para finalizar o processo.",
  "by entering my personnal informations": " inserindo as minhas informações pessoais",
  "Want to rent my product ? No problem ! It only takes a few minutes to subscribe online":
    "Eu desejo fazer um contrato de locação? Nada é mais simples ! Eu faço o meu pedido de locação online.",
  "Here are the steps to follow for your rental request !":
    " Aqui estão as étapas a seguir para continuar o seu pedido de locação!",
  "Then i finalize my order in shop under 5 days, bringing with me those 3 proofs":
    "Depois eu finalizo em loja o meu pedido de locação até um máximo de 5 dias, levando comigo os 3 documentos justificativos seguintes:",
  "To complete your subscription request, bring the following items, all of which must be in your name :":
    "Para realizar o seu pedido de subscrição, tenha consigo os seguintes elementos que devem contrer o seu nome:",
  "Here are the steps to follow to make your rental request":
    "Estes são os passos a seguir para fazer o seu pedido de locação",
  "The online subscription procedure is fully dematerialized.":
    "O procedimento de inscrição online é totalmente desmaterializado.",
  "The online subscription procedure is completely dematerialized. The signing of your contract and the sending of your supporting documents will be done electronically.":
    "O processo de subscrição é desmaterializado. A assinatura do seu contrato e o envio dos documentos comprovativos serão feitos de forma electrónica.",
  "The signing of your contract and the downloading of your supporting documents will be done by electronic way.":
    "A assinatura do seu contrato e o download dos documentos comprovatórios serão feitos de forma eletrônica.",
  "Select your services and customize the options of your rental contract.":
    "Seleccione os seus serviços e personalize as opções do seu contrato de renting",
  "Select your services, durations and customize the options of your rental contract.":
    "Escolha a duração e as opções do seu contrato de locação",
  "Pay by credit card the 1st installment of your rental contract.":
    "Pague com cartão de crédito o primeiro pagamento do seu contrato de locação.",
  "Wij vragen u vriendelijk een eerste betaling te doen ter waarde van de éénmalige kosten onder uw Private Lease Contract. Dat is dus":
    "Esta etapa é apenas uma solicitação de autorização de pagamento. A 1ª parcela de",
  "Nadat uw eerste betaling is ontvangen en uw aanvraag is ingediend, zal Evollis uw aanvraag beoordelen. Evollis zal u eventueel verzoeken om aanvullende informatie te verstrekken. Pas nadat Evollis uw aanvraag definitief heeft aanvaard, komt het Private Lease contract tot stand. Als mocht blijken dat u onverhoopt niet in aanmerking kunt komen voor Private Lease, dan krijgt u de eerste betaling weer teruggestort op uw rekening. Daarnaast heeft u uiteraard het recht om binnen 14 dagen nadat u uw aanvraag heeft ingediend, het contract kosteloos te beëindigen. In dat geval krijgt u de eerste betaling ook weer teruggestort op uw rekening.":
    "Por cartão de crédito só terá efeito após o download dos seus documentos comprovativos e após a assinatura do seu Contrato de Aluguer",
  "De eerste betaling zal middels iDEAL door onze service provider Adyen worden uitgevoerd. Adyen B.V. is een besloten vennootschap met beperkte aansprakelijkheid. Adyen B.V. staat geregistreerd bij de Kamer van Koophandel onder nummer 34259528 en is gevestigd aan de Simon Carmiggeltstraat 6-50, 1011 DJ Amsterdam, Nederland.":
    "Se o seu pedido de aluguer for posteriormente recusado pelo locador após o seu estudo, este valor será imediatamente reembolsado.",
  adyen_first_payment_intro: "Esta etapa é apenas uma solicitação de autorização de pagamento. A 1ª parcela de",
  adyen_first_payment_review:
    "Por cartão de crédito só terá efeito após o download dos seus documentos comprovativos e após a assinatura do seu Contrato de Aluguer",
  adyen_first_payment_provider:
    "Se o seu pedido de aluguer for posteriormente recusado pelo locador após o seu estudo, este valor será imediatamente reembolsado.",
  "through bank card to reserve my product": "através do cartão do banco para reservar meu produto",
  "Check and complete your personal information which will appear on your contract.":
    "Verifique e preencha os seus dados pessoais que constarão no seu contrato.",
  "which will appear on my location's contract": "que vão aparecer no meu contrato de locação",
  "Validate your personal information and your rental request.":
    "Valide as suas informações pessoais e o seu pedido de renting.",
  "which allow me to validate my informations and my rent request":
    "que me permite validar as minhas informações e o pedido de locação",
  "Download your supporting documents and sign your dematerialized contract.":
    "Faça o download dos seus documentos comprovativos e assine o seu contrato de renting de forma desmaterializada.",
  "Obtain acceptance in principle then finalize your order in the store of your choice.":
    "Obtenha uma pré-aceitação e finalize o contrato na em loja.",
  "I get a principle acceptation to rent my product": "Eu obtenho uma pré-aceitação para a locação do meu produto",
  "To complete your subscription request, have the following information ready:":
    "Para concluir o seu pedido, tenha as seguintes informações preparadas:",
  "Only if the address of your RIB differs from your current address":
    "Só se a morada do seu IBAN for diferente da sua morada actual",
  "Only if the address of your RIB differs from your current address or the amount of product > 3000€ttc.":
    "Só se a morada do seu IBAN for diferente das sua morada actual ou o produto tenha um valor > 3000€PVP.",
  "To speed up the study of your file, prefer an invoice indicating your telephone number entered in the form":
    "Para acelerar o processo de análise do seu pedifo, escolha uma factura que indique o seu número de telefona introduzido no formulário.",
  bpls_onboarding_first_title: "Finalisez votre commande Samsung Rent+ Pro en 3 étapes : ",
  bpls_onboarding_second_title: "Protega-se : ",
  bpls_onboarding_step_client_title: "Complete",
  bpls_onboarding_step_informations_paragraph: "as suas informações",
  bpls_onboarding_step_summary_title: "Submeta",
  bpls_onboarding_step_summary_paragraph: "o seu pedido de locação",
  bpls_onboarding_step_loader_title: "Assine electrónicamente",
  bpls_onboarding_step_loader_paragraph: "o seu contrato",
  /* ========================================== */
  /* SERVICES PAGE ============================ */
  /* ========================================== */
  "Gain peace of mind by protecting your product throughout the rental period.": "Serviços",
  "Read the insurance notice": "Leia a política de seguro",
  "Full warranty": "Garantia completa",
  Upgrade: "Renovação",
  "Dedicated customer service": "Sercivi cliente exclusivo",
  "Accidental breakage": "Quebra acidental",
  "Accidental oxidation": "Oxidação acidental",
  "Accidental action": "Acção acidental",
  "Global coverage": "Cobertura mundial",
  "No deductible applied": "Nenhuma dedução aplicada",
  "14 days withdrawal period": "14 dias de período experimental",
  "Telephone assistance 6 days a week": "Assistência telefónica 6 dias por semana",
  Pickpocketing: "Carteiristas",
  "Theft by assault or break-in": "Roubo por assalto ou invasão",
  "Fraudulent use": "Utilização fraudulenta",
  None: "Nenhum",
  Breakage: "Quebra",
  "Breakage and theft": "Quebra e roubo",
  "or a rent of ": "ou uma mensalidade de ",
  Cap: "",
  "2 claims maximum per insurance year. Ceiling 1500 € per insurance year.": "",
  "Main exclusions": "",
  "The accessories, and connectors of the device. Normal wear and tear of the device. Negligence, forgetting the device. Theft from the primary and secondary residence.":
    "",

  "I acknowledge having read and accept the general conditions of the long-term rental contract offer and the service contract.":
    "Eu valido que li e aceito as condições gerais do contrato de locação de longa duração, da oferta e dos serviços associados ao contrato",
  "I request the start of the execution of my long-term rental contract with the lessor and my service contract before the expiration of the 14-day withdrawal period.":
    "Eu requisito o começo do contrato de locação de longa duração com o Locador e serviços associados antes do período de expiração de 14 dias para devolução do produto",
  "I confirm that I do not choose optional insurance and assume the risk of breakage or theft during my long-term rental contract.":
    "Eu confirmo que não escolhi a subscrição de seguro e assumo os riscos por quebra ou roubo do produto ao longo da duração do contrato de locação.",
  "I confirm my subscription to breakage insurance and acknowledge having read the insurance information notice.":
    "Eu confimo a minha adesão ao seguro de quebra e reconheço que li a politica de informação da seguradora.",
  "By checking this box, I authorize Cardif Assurances Risques Divers to use my email address for the execution of my contract. However, I recognize that certain documents must be sent to you in the original and that you will inform me if the case arises. I note that this data (email address) will not be used for commercial solicitation purposes, unless I have expressly consented otherwise. I have the right to oppose exchanges by e-mail at any time by sending my request to data.protection@cardif.com or to CARDIF Assurances Risques Divers - Claims quality department - Prévoyance SH 123- 8 rue du Port - 92 728 Nanterre Cedex.":
    "",
  'Up2You\'s breakage and thief protection is a collective damage insurance (number 674) contract subscribed by Samsung Electronics France, society with a capital of 27 000 000 euros – 334 367 497 RCS Bobigny – Siège social 1, rue fructidor 93484 Saint-Ouen auprès de CARDIF - Assurances Risques Divers - S.A. (society with a capital of 16 875 840 euros) 308 896 547 RCS Paris - Siège social : 1, Boulevard Haussmann 75009 Paris - Entreprise ruled by the insurance code, here called "CARDIF"':
    "",
  "Up2YOu Location's breakage and thief insurance is distributed as an accessory relatively to it main commercial activity by Samsung Electronics France by the way of Garantie-privée SAS, insurance society with a capital of 60 000 € - 521 279 737 RCS Bordeaux, - Siège social : 7-9 allée Haussmann 33300 Bordeaux, registered to l’ORIAS ( www.orias.fr ) under the reference 100 557 38.":
    "",
  "Up2You location breakage and thief contract' sinister handling is the responsability of Grantie-Privée, insurance broker":
    "",
  "You have a 14-day cooling-off period for a remote rental request from the conclusion of your long-term rental contract. Non-contractual photo.":
    "Dispõe de 14 dias de período experimental após início do seu contrato locação. Fotos não contratualizadas.",
  "You have not chosen an insurance option": "Não escolheu nenhuma opção de seguro",
  "Be aware that in case of breakage or theft, you will have to pay for repairs to the product or its replacement. Remember to protect your device for peace of mind, as the breakdown guarantee does not cover breakage or theft.":
    "Saiba que em caso de quebra ou roubo, irá pagar a reparação do produto ou a sua substituição. Pense em proteger o seu produto para que esteja mais tranquilo. Recorde-se que a garantia não cobre a quebra ou robo do seu produto.",
  "*see general conditions in the insurance notice": "*veja as condições gerais da política de seguro",
  /* ========================================== */
  /* UPFRONT PAGE ============================= */
  /* ========================================== */
  "first installment of your rental contract": "Primeiro pagamento do seu contrato de locação",
  "Cards accepted": "Cartão aceite",
  "Cards not accepted": "Cartões rejeitados",
  "Systematic authorization cards (Electron, Maestro, pre-paid or rechargeable), American Express and e-CB.":
    "Cartões de autorização sistemática (Electron, Maestro, pré-pago ou recarregável), American Express e e-CB.",
  "This step only constitutes a request for authorization of payment.":
    "Esta etapa é apenas uma solicitação de autorização de pagamento.",
  " The 1st payment of ": " A 1ª parcela de ",
  " by credit card will only be effective after signing your rental contract and downloading your supporting documents.If your rental request is subsequently refused by the Lessor following its study, then this amount will be immediately refunded.":
    " por cartão de crédito só terá efeito após o download dos seus documentos comprovativos e após a assinatura do seu Contrato de Aluguer. Se o seu pedido de aluguer for posteriormente recusado pelo locador após o seu estudo, este valor será imediatamente reembolsado.",
  "Systematically authorized cards (such as Electron, Maestro, prepaid, rechargeable), e-CB and American Express.":
    "Cartões com autorização sistemática (Electron, Maestro, cartões pré-pagos ou recarregáveis, American Express e e-CB.",
  "Upfront amount of your leasing contract": "Montante do primeiro pagamento do seu contrato de locação",
  "Card number": "Número do cartão",
  MM: "MM",
  CB: "CB",
  Visa: "Visa",
  Mastercard: "Mastercard",
  Cancel: "Anular",
  "Your credit card is expired": "O seu cartão de crédito expirou",
  "Expiration date": "Data de Validade",
  CVV: "CVV",
  "I, undersigned $ certify that I am the holder of the bank card used for the request for payment of my 1st payment.":
    [
      "Eu, abaixo assinado, ",
      " certifico que sou titular do cartão bancário utilizado para o pedido de autorização para o meu primeiro pagamento."
    ],
  "Secured payment": "Pagamento seguro",
  "validate the payment authorization": "Validar a autorização de pagamento",
  "Your card has been declined. Please check the accuracy of the information entered. You can also contact your bank to verify that it is not blocking payment.":
    "O seu cartão foi recusado. Por favor verifique a validade da informação inserida. Poderá também contatar o seu banco para verificar a razão do bloqueamento do pagamento.",
  /* ========================================== */
  /* CLIENT DATA PAGE ========================= */
  /* ========================================== */
  "Bank Seniority": "Ano de ingresso no seu banco atual",
  "My identity": "Minha identidade",
  "My Leader identity": "Identité du dirigeant",
  "My coordinates": "Meu contacto",
  "Leader coordinates": "Coordonnées du dirigeant",
  "My situation": "Minha situação",
  "My budget": "Meu orçamento",
  "The information below is necessary for our renter for the constitution of your rental file.":
    "Las informaciones debajo son necesarias para nuestro arrendador para la constitución de tu dosier de arrendamiento",
  "To meet our eligibility conditions, you must have regular activity income and not have any current payment incidents.":
    "Para rellenar nuestras condiciones de elegibilidad, debes tener un trabajo con ingresos regulares y no tener incidentes de pago en curso.",
  Identity: "Identidad",
  Title: "Título",
  Mr: "Senhor",
  Ms: "Senhora",
  "Last name": "Apelidos",
  "leader first name": "Prénom du dirigeant",
  "leader name": "Nom du dirigeant",
  "Last second name": "Segundo apelido",
  "Maiden name": "Segundo apellido",
  "If you are not married, enter your name again.": "Si no está casado, vuelva a ingresar su nombre.",
  "First name": "Nome próprio",
  "Tax number": "Número de Identificação Fiscal (NIF)",
  Address: "Morada",
  "Enter the address that will appear on your contract.": "Preenche a morada que aparecerá no teu contrato",
  "Address 2": "Complemento de morada",
  Locality: "Localidade",
  Zip: "Código postal",
  City: "Cidade",
  Birth: "Nacimiento",
  Birthdate: "Data de Nascimento",
  "Department of birth": "Local de Nascimento",
  "City of birth": "Naturalidade",
  "Country of birth": "País de nascimento",
  Citizenship: "Nacionalidade",
  Contact: "Contacto",
  Mobile: "Telemóvel",
  Email: "Email",
  Occupation: "Ocupação",
  "Since...": "Desde",
  " since ": " desde ",
  Finances: "Finanzas",
  "Your net monthly income": "Vencimento líquido mensal",
  "over 12 months": "Mais de 12 meses",
  "over 13 months": "Mais 13 meses",
  "over 14 months": "Mais 14 meses",
  "over 15 months": "Mais 15 meses",
  "over 16 months": "Mais 16 meses",
  "Other monthly income": "Outro rendimento mensal",
  "Property income or alimony paid": "Rendimento de propriedade ou pensão alimentícia paga",
  "Your share of monthly charges": "A sua parte de custos mensais",
  "Rent or mortgage": "Renda ou empréstimo hipotecário",
  "Rent or mortgage EVO":
    "Renda(s) ou parcela(s) de crédito(s) imobiliário(s), Crédito em curso fora do imóvel, Custos com creche",
  "Net monthly income tooltip":
    "Salário + bónus(s), Aposentadoria(s) e pré-aposentadoria(s), Rendimentos de atividade liberal, Pensões, etc.",
  "Other monthly charges": "Outros cargos mensais",
  "Credit (excluding mortgage) and / or alimony paid":
    "Crédito (excluindo empréstimo hipotecário) e ou pensão alimentícia paga",
  Housing: "Habitação",
  "Contract type": "Tipo de contrato",
  "Family situation": "Situação Familiar",
  "Number of dependent children": "Número de filhos",
  "Bank account": "Cuenta bancaria",
  IBAN: "IBAN",
  "BIC or SWIFT": "BIC or SWIFT",
  "IBAN bpls": "IBAN Empresa",
  firm_bloc_title: "",
  Company: "",
  "Company name": "",
  "Company siren": "",
  "Company siret": "",
  "Company siret infos": "",
  "Executive birthdate": "",
  "Executive title": "",
  "Executive lastname": "",
  "Executive firstname": "",
  "Executive birthdate infos": "",
  "Company isSameAddress": "",
  Signatory: {
    propsValues: (props) => {
      const { data } = props
      return `Signataire ${data}`
    }
  },
  "Signatory tooltip":
    "Afin de valider votre projet de financement, veuillez compléter vos informations signataires. Les signataires sont les personnes qui ont le pouvoir de signer pour le compte de l’entreprise. Ces informations seront utilisées uniquement pour la signature électronique de votre contrat.",
  "Executive civility tooltip": "Estas informações dizem respeito ao dirigente principal da empresa",
  "Add signatory": "Criar um assianante",
  "Remove signatory": "Retirar um assinante",
  "Signatory name": "Apelido do assinante",
  "Signatory first name": "Primeiro nome do assinante",
  "Signatory birthdate": "Data de nascença do assinante",
  "Signatory email": "E-mail do assinante",
  "Signatory email info":
    "O contrato será enviado para este e-mail. O e-mail inserido deve ser um e-mail pertecente a uma pessoa física e não um e-mail genérico.",
  "Signatory mobile phone": "Número de telefone do assinante",
  "Signatory mobile phone infos":
    "Um código será enviado pour SMS para autentificar o assinante e validar a assinatura electrónica.",
  Bank: "Os seus dados bancários",
  "Company bank details": "Detalhes bancários da empresa",
  "Bank account owner": "Titular da conta",
  Adresses: "A sua Morada",
  "Shipping address": "Morada de entrega",
  "Shipping address 2": "Complemento de morada de entrega",
  "Billing address 2": "Complemento de morada de facturação",
  "Billing adress": "Morada de facturação",
  /* ========================================== */
  /* SUMMARY ================================== */
  /* ========================================== */
  "Read each document (tab), download your supporting documents. You will be able to accept the conditions of the contract by checking the boxes and electronically sign your contract with a code that you will receive by SMS.":
    "Leia cada documento e faça o download dos seus documentos comprovativos. Poderá aceitar as condições do contrato ao clicar nas caixas de seleção e assinar eletronicamente o seu contrato com um código que receberá por SMS.",
  within: "dentro de",
  "I agree to receive electronically commercial offers from companies in the BNP Paribas Personal Finance group.":
    "Aceito receber ofertas promocionais por via eletrónica de empresas do grupo Evollis.",
  "I oppose the receipt of commercial offers by post or telephone from BNP Paribas Personal Finance group companies.":
    "Não concordo em receber ofertas promocionais por correio ou por telefone de empresas do grupo Evollis.",

  "Edit my data": "Modificar as minhas informações",
  "We ask your consent for all the purposes described in data processing :":
    "Pedimos-lhe que dê o seu consentimento para a recolha e tratamento de dados ",
  "I agree that the start date of my Rental contract, end date of my Rental contract, renewal date of my Rental contract and that the duration of my Rental contract be sent to Rue du Commerce in order to allow manage my Rental contract from my Rue du Commerce customer area.":
    "",
  "Confirmo que li e aceito as Condições Gerais de Locação e a Política de Privacidade. Também autorizo o débito do primeiro pagamento único relativo ao contrato de locação na minha conta bancária, bem comme o débito mensal do aluguel.":
    {
      elementHtml: (props) => {
        const hrefContract = getStaticDocUrl(
          props?.tunnelData,
          "contract",
          "https://static-seib.evollis.com/pdf/contract_pt.pdf"
        )
        const hrefPrivacy = getStaticDocUrl(
          props?.tunnelData,
          "privacy",
          "https://static-seib.evollis.com/pdf/privacy_pt.pdf"
        )
        return (
          <React.Fragment>
            {" "}
            Confirmo haber leído y aceptado las
            <a href={hrefContract} target="_blank" rel="noopener noreferrer" alt="">
              {" "}
              Condiciones Generales de Alquiler{" "}
            </a>
            y la{" "}
            <a href={hrefPrivacy} target="_blank" rel="noopener noreferrer" alt="">
              {" "}
              Política de Privacidad.
            </a>{" "}
            También autorizo el cargo del primer pago único relacionado con el contrato de alquiler en mi cuenta
            bancaria, así como el cargo mensual del alquiler.
          </React.Fragment>
        )
      }
    },
  /* ========================================== */
  /* NETHEOS ================================== */
  /* ========================================== */
  "Your product will be delivered to you after the final acceptance of the long-term rental contract and upon receipt of supporting documents by the rental company.":
    "O seu produto será entregue após a aceitação final do contrato de locação de longo prazo e após o recebimento dos documentos comprovativos pelo locador.",
  /* ========================================== */
  /* CONFIRMATION ============================= */
  /* ========================================== */
  "Request sent": "Pedido enviado",
  "Your file number is": "O seu número de contrato é",
  "Now, we need to review it and determine if you are eligible for our offer. A response will be provided to you within 48 hours.":
    "Agora, precisamos analisá-lo e determinar se você é elegível para a nossa oferta. Uma resposta será fornecida em 48 horas.",
  "BPLS confirmation text":
    "Só lhe resta assinar o seu contrato electrónicamente para começar o processo de entrega do seu produto. Irá receber um email do no parceiro DocuSign para assinar eletrónicamente o seu contrato.",
  "Upon confirmation of acceptance of your file, you can go to the store to get your product.":
    "Desde que o seu contrato seja aceite, pode se dirigir à loja para recuperar o seu produto.",
  "Thank you for your trust and see you soon !": "Obrigado pela sua confiança e até breve!",
  /* ========================================== */
  /* ACCEPTANCE PAGE ========================== */
  /* ========================================== */
  lets_go: "Aqui vamos nós !",
  "Let's go ! I have ": "Vamos! Eu tenho ",
  you_have_x_days_to: {
    propsValues: (props) => {
      const { offerDroppingDelay, shop } = props
      return `Tem ${offerDroppingDelay} dias para se apresentar na loja ${shop} para finalizar o seu pedido de locação apresentando os seguintes documentos:`
    }
  },
  "days to go personally to a {store} store to finalize my request with the following documents:":
    "dias para me apresentar pessoalmente numa loja adim de finalizar o meur pedido de subscrição e trazer comigo os seguintes documentos:",
  Acceptance: "Aceitação",
  "Acceptance in principle": "Princípio de aceitação",
  "Your subscription request": "O seu pedido de subscrição",
  "has been accepted in principle.": "recebeu uma pré-aceitação.",
  "You have ": "Tem ",
  " days": " dias",
  "to go to your store in order to finalize your subscription request by bringing the following documents:":
    "para voltar à loja e finalizar o processo de subscrição e trazar consigo os seguintes documentos:",
  "A confirmation email of your order": "Un email de confirmação do seu contrato",
  "has just been sent.": " será enviado.",
  "Request pre-accepted": "Pedido pré-aceite",
  "Pre accepted paragraph one": {
    elementHtml: (
      <>
        Antes de dar o produto ao cliente, por favor assegure-se que o contrato se encontra no estado{" "}
        <strong>“Aceite - à espera de financiamento”</strong>.
      </>
    )
  },
  "Pre accepted paragraph two": {
    elementHtml: (
      <>
        <strong>O cliente deseja levar já o produto consigo?</strong> Por favor contacte um conselheiro Evollis através
        do número <strong>937 845 574</strong> de segunda a sexta de das 10:00 às 21:00 e Sábado e Domingo das 11:00 às
        21:00.
      </>
    )
  },
  "Pre accepted paragraph three": {
    elementHtml: <small></small>
  },
  "Pre accepted paragraph four": {
    elementHtml: <>Entregar o original do documento de entrega do produto ao cliente.</>
  },
  "Pre accepted paragraph five": {
    elementHtml: <>Fazer o upload da ata de entrega assinada pelo cliente.</>
  },
  "Print the rental voucher": "Imprimir o documento de locação",
  generate_delivery_voucher: "Gerar documento de entrega",
  voucher_ready: "O seu documento está pronto. Pense em imprimir o documento de locação",
  error_voucher_retrieval: "Foi produzido um erro após a recuperação do documento de locação.",
  "No rental voucher": "Nenhum documento de locação disponível",
  final_page_import_document: "Importar um documento",
  finalize_later: "Finalizar mais tarde",
  pdi_retail_opl: "Número de encomenda",
  pdi_retail_store_id_label: "Número da loja",
  pdi_retail_partner_order_id_label: "Número de encomenda do distribuidor*",
  pdi_retail_imei_marquage_label: "Número IMEI / marcação",
  pdi_retail_mm_order_digits: "Introduza exatamente 8 dígitos.",
  import_document: "Importar um documento",
  /* ========================================== */
  /* SCORE-LOADER PAGE =================================== */
  /* ========================================== */
  scoreLoaderTitle: "O seu contrato de locação encontra-se em fase de análise",
  scoreLoaderSubtitle: "Por favor, aguarde.",
  scoreLoaderText: "Irá receber uma resposta muito em breve.",
  /* ========================================== */
  /* SCORE-PENDING PAGE =================================== */
  /* ========================================== */
  bplsPendingScoreTitle: "O seu contrato de locação encontra-se em fase de análise",
  bplsPendingScoreText: " Nós responderemos brevemente por e-mail,",
  bplsPendingScoreOrderSubtitle: "O seu contrato de locação financeira",
  bplsPendingScoreOrderText: {
    propsValues: (props) => {
      const { opl, externalReference } = props
      return `N° demande ${externalReference} - ${opl}`
    }
  },
  bplsPendingScoreOrderTextDuration: {
    propsValues: (props) => {
      const { defaultDuration, monthlyTotalTaxesExcluded } = props
      return `Loyer ${defaultDuration} mois : ${monthlyTotalTaxesExcluded} € HT / mois.`
    }
  },
  /* ========================================== */
  /* SCORE-OK PAGE =================================== */
  /* ========================================== */
  bplsScoreOkTitle:
    "O seu contrato de locação financeira foi aceite.O seu contrato está pronto para ser assinado electrónicamente.",
  bplsScoreOkSubtitle: "O seu contrato de locação financeira foi aceite.",
  bplsScoreOkText:
    " Só lhe resta assinar o seu contrato para accionar a entrega do produto seleccionado.Irá receber un e-mail do nosso parceiro DocuSign para assinar eletrónicamente o seu contrato.",
  spamWarningBpls:
    "Na ausência de um email recebido na sua caixa de email, por favor verifique no separado spam En l’absence d’email reçu dans votre boite de réception, vérifiez dans vos courriers indésirables.",
  /* ========================================== */
  /* SCORE-KO PAGE =================================== */
  /* ========================================== */
  bplsScoreKoTitle: "O seu pedido para um contrato de locação foi recusado",
  bplsScoreKoSubtitle: " Lamentamos informá-lo que não podemos dar continuidade ao seu contrato.",
  bplsScoreKoText:
    "Nós convidamo-lo a regressar ao seu carrinho e a seleccionar a opção de compra para finalisar o seu contrato",
  /* ========================================== */
  /* LEGALS =================================== */
  /* ========================================== */
  "This is a long-term rental contract, which the consumer concludes with Evollis S.A.S. The consumer will first be asked to make a first payment and provide information. It is only after Evollis has evaluated this information and has definitively accepted the request, that the contract will be concluded. Evollis S.A.S. is a limited liability company under French law with its registered office at 22 quai de Bacalan, 33300 Bordeaux, France, registered in the French trade register under number 530612571; VAT number: FR 19530612571.":
    "Contrato de locação serviço celebrado com a Evollis, SAS, com um capital de 166 190,60 €, com sede em 22-26 Quai de Bacalan 33300 Bordéus - RCS Bordéus número 530 612 571 -  Número ORIAS: 13003909.  N°ADEME : FR320894 _03JPOV",
  "Long-term rental contract, subject to acceptance of the file by the Lessor, Evollis, a Simplified Joint Stock Company under French law, with a capital of € {shareCapitalFinancer} , having its head office at 22 quai de Bacalan, 33300 Bordeaux, France, registered in the French trade register under number 530612571; VAT number: FR 19530612571.":
    "Contrato de locação celebrado com a Evollis SAS, com o capital de {shareCapitalFinancer} €, com sede em 22-26 Quai de Bacalan 33300 Bordeaux, inscrita no Registro de Comércio e Sociedades de Bordéus sob o número 530 612 571. Número fiscal intracomunitário: FR 195 306 125 71.  N°ADEME : FR320894 _03JPOV",
  "Long-term rental contract, subject to acceptance of the file by the Lessor Personal Finance Long-term rental contract, subject to acceptance of the file by the Lessor Personal Finance Location and after expiration of the legal withdrawal period. Personal Finance Location - SASU with a capital of € 1,500,000 - Headquarters: 1 boulevard Haussmann - 75009 Paris - RCS Paris N °433 911 799.":
    "Aluguer de longa duração, sujeito a aceitação por parte da Locadora Evollis e após o prazo legal de rescisão. Evollis, Société par Actions Simplifiée com um capital de 166 190,60 €, com sede em 22 Quai de Bacalan 33300 Bordeaux, inscrita no Registro de Comércio e Sociedades de Bordéus sob o número 530 612 571, representada pelo Sr. Emmanuel GILLET, na sua qualidade como Diretor Geral, devidamente autorizado para os fins deste documento.",
  "Service's contract handled by Micromania SAS society with a capital of 32 230 000 € with head office at 955, Route des Lucioles, Valbonne 06560 ; Registered to the Registre du Commerce des sociétés de Grasse under the reference SIREN 418 096 392.":
    "",
  "The information requested is for the management of your leasing request. Unless otherwise stated, they are mandatory and in the absence of a complete response, your request may be refused. If you choose not to let us know, we will not be able to process your request. They are intended for the Lessor, Personal Finance Location, data controller. Through it, you will be able to receive proposals from partners. For more information on the processing of your personal data by Personal Finance Location and on your rights (right of access, rectification, erasure, limitation of processing, data portability, right of opposition and right to organize the management of your data after your death) you can refer to the information notice on the use of personal data or contact us at the following address at Personal Finance Location - Customer Service - 62061 Cedex 9 - consommateurs.donneespersonnelles@cetelem.fr":
    "",
  "The information requested is for the management and evaluation of your Service Contract. Unless otherwise stated, they are mandatory and in the absence of a complete response, your request may be refused. If you choose not to let us know, we will not be able to process your request. They are intended for EVOLLIS, responsible for the processing. Through it, you will be able to receive proposals from partners. For more information on the processing of your personal data by EVOLLIS and on your rights (right of access, rectification, erasure, limitation of processing, data portability, right of opposition and right to organize the management of your data after your death) you can refer here to the use of your data or contact us at the following address EVOLLIS - Customer Service - 22 quai de Bacalan - 33300 Bordeaux or at protectiondonnees@evollis.com":
    "As informações solicitadas são necessárias para a gestão do pedido de celebração do contrato de locação e da utilização desta aplicação. Salvo indicação em contrário, tais informações são obrigatórias e deverão ser completas já que, de outra forma, o seu pedido de celebração do contrato de locação poderá ser recusado. Caso opte por não comunicar as informações, não poderemos processar o seu pedido. As informações são destinadas ao locador Evollis, responsável pelo seu tratamento. Por meio da Evollis, você pode receber propostas de empresas parceiras. Para mais informações sobre o tratamento dos seus dados pessoais pela Evollis e sobre os seus direitos (direito de acesso, retificação, eliminar, limite de tratamento, transferência de dados, direito de oposição e direito de organizar a gestão dos seus dados após a morte), pode aceder a informação  sobre a utilização de dados pessoais aqui.",
  "Service contract managed by EVOLLIS - SAS with capital of € 1,277,010 - Headquarters: 22 Quai de Bacalan 33300 Bordeaux - RCS Bordeaux N ° 530 612 571 - Intra-community VAT number: FR 195 306 125 71 - ORIAS number: 13003909.":
    "Contrato de prestação de serviços administrado pela Evollis - SAS com capital de 130 698,6 0 euros - Sede: 22 Quai de Bacalan 33300 Bordeaux - RCS Bordeaux N ° 530 612 571 - CPF: FR 195 306 125 71 - ORIAS: 13003909.",
  "You also have, in accordance with article L 223-2 of the Consumer Code, a right to register on the list of opposition to canvassing available on the website www.bloctel.gouv.fr. This registration prohibits a professional from canvassing by telephone, except in the case of pre-existing contractual relationships.":
    "",
  "Unless otherwise stated, the informations asked are mandatory. Collected data will be used by Personal Finance Location, data controller, in order to make your rent request succeed. They allow us to propose you adapted offers, and satisfy our legal obligations. If you need more information about data's treatment, and to exercise your rights : access right, rectification right, erasement right, treatment's limitation right, data portability, opposition right ( including the use of your personal data for prospecting purposes ) and the right to organize the management of your data after your death, please contact us at Personal Finance Location – Service Clients – 62061 ARRAS Cedex 9 - consommateurs.donneespersonnelles@cetelem.fr .":
    "",
  "You can object to receiving commercial prospecting by telephone by registering for free on the list of opposition to telephone canvassing on the website www.bloctel.gouv.fr or by post to - Société Opposetel, Service Bloctel, 6 rue Nicolas Siret 10000 Troyes. This registration prohibits a professional from canvassing you by telephone, unless this solicitation occurs in the context of the execution of a current contract and it has a connection with the subject of this contract.":
    "",
  "The evaluation of your file is subject to automated processing, which may result in the refusal of your subscription request. You have the right to obtain human intervention, to express your point of view and to contest the decision by contacting us at the following address: Personal Finance Location - 62061 Arras - Cedex 9 or by email: serviceclientspflocation @ bnpparibas -pf.com":
    "A avaliação do seu pedido está sujeita a um tratamento automatizado que pode fazer com que seja rejeitado. Tem o direito de obter uma intervenção humana, de expressar o seu ponto de vista e de questionar a decisão, contactando-nos para o seguinte endereço: Evollis - 22 Quai de Bacalan - 33300 Bordeaux ou por e-mail: xxxxx",
  /* ========================================== */
  /* ERROR PAGES ============================== */
  /* ========================================== */
  "Internal error": "Erro interno",
  "The server was unable to process your request.": "O servidor não pode processar o seu pedido.",
  "The server has encountered an error, and couldn't treat your request.":
    "O servidor encontrou um error, e não pode processar o seu pedido",
  "Page not found": "Página não encontrada",
  "The page you're asking for doesn't exist or had been deleted": "A página que procura não existe ou foi removida",
  "Service unavailable": "Serviço indisponível",
  "Service is unavailable, please come back later.":
    "O serviço está temporáriament indisponível, for favor volte mais tarde.",
  "Pending request": "Pedido pendente",
  "We will send you an email allowing you to finalize your file later.":
    "Iremos enviar-lhe um email que lhe permitirá finalizar o seu arquivo mais tarde",
  "You have 2 days to finalize your request by uploading your supporting documents.":
    "Você tem 2 dias para finalizar sua solicitação, enviando seus documentos de suporte.",
  "Without your supporting documents, your file will be canceled within 3 days.":
    "Sem os documentos comprovativos, o seu pedido será cancelado no prazo de 3 dias.",
  /* ========================================== */
  /* VALIDATION =============================== */
  /* ========================================== */
  "Not a valid IBAN": "IBAN inválido",
  "Not a valid BIC": "BIC inválido",
  Required: "Campo obrigatório",
  "Enter data": "Introduzir os dados",
  "Invalid data": "Dados inválidos",
  "Date is not valid": "Data inválida",
  Maximum: "Máximo",
  characters: "caracteres",
  "maximum characters": "Caracteres máximos",
  "Unauthorized characters": "Caracteres não autorizados",
  "Phone number must start with 06 or 07 and contain 10 numbers":
    "O número de telefone deve começar com 06 ou 07 e conter 10 números",
  "Invalid phone number": "Número inválido",
  "Invalid phone number fnac": "Insira o número de telemóvel após o indicativo +351",
  "Invalid postal code": "Código postal inválido",
  "Minimum age must be > 18 years old": "A idade mínima deve ser de 18 anos.",
  "Maximum age must be < 110 years old": "A idade máxima deve ser de 110 anos.",
  "Must be positive": "O número tem de ser positivo",
  "minimum characters": "Caracteres mínimos",
  "number of children must be contains between 0 and 10": "O número de filhos deve ser entre 0 e 10.",
  "birthDate is not valid": "Data de nascimento inválida",
  "employmentDate cannot be before birthDate": "A data de contratação não pode ser anterior à data de nascimento",
  "Year seniority bank cannot be before birth date":
    "Data de abertura de conta não pode ser anterior à data de nascimento",
  "difference between employment date and birth date must be at least 16 years":
    "A diferença entre a data de contratação e a data de nascimento tem de ser de pelo menos 16 anos.",
  "difference between bank seniority date and birth date must be at least 16 years":
    "A data de abertura de conta e a data de nascimento tem de ser de pelo menos 16 anos.",
  "employmentDate cannot be in future": "Data de contratação não pode ser no futuro.",
  "Must be a whole number": "Deve ser um número inteiro",
  "Must be a number": "Deve ser um número",
  "Email invalid": "Endereço electrónico inválido",
  "Please assert you're the real card owner": "Por favor confirme que é o proprieatário do cartão.",
  "Not a valid MM value": "Insira o mês no formato MM",
  "Not a valid YYYY date": "Insira o ano no formato AAAA",
  "Not a valid date": "Data inválida",
  "Can't be before current year": "Não pode ser antes do ano atual",
  "Must be composed of 3 digits": "Deve ser composto por 3 dígitos",
  "Must be composed of 12-19 digits": "Deve ser composto por 12-19 dígitos",
  "Not a valid YYYY-MM-DD date": "Insira uma data no formato DD/MM/AAAA",
  "Residence date cannot be before birth date": "A data de residência não pode ser anterior à data de nascimento",
  "This date cannot be in future": "Esta data não pode ser no futuro",
  "Employment date cannot be before birth date": "A data de contratação não pode ser annterior à data de nascimento",
  "Employment date cannot be in future": "A data de contratação não pode ser no futuro",
  "Please pick a correct value": "Por favor, escolha um valor correcto",
  validator_invalidNetMounthlyIncomeFormat: "N/A",
  validator_endContractDateInFuture: "N/A",
  /* ========================================== */
  /* OK KO BACK =============================== */
  /* ========================================== */
  "Your request is already finalized": "O seu pedido encontra-se finalizado",
  "You will receive a final response within 24 hours.": "Irá receber a resposta final em 24 horas.",
  "Thank you for your request.": "A Evollis agradece o seu pedido.",
  "Your request has already been validated": "O seu pedido já foi validado",
  "The information you have entered can no longer be changed.": "A informação inserida não pode ser alterada.",
  "Please click on the button below to finalize your order.":
    "Por favor clique no botão abaixo para finalizar o seu pedido.",
  "Finalize your order": "Finalize o seu pedido",
  "Operation failed": "A operação falhou",
  "Your order is canceled. The amount of the upfront will not be deducted from you.":
    "O pedido de locação foi anulado e o montante para o pagamento no cartão de crédito não sera cobrado.",
  please_study_other_payment_means:
    "Convidamo-lo a vir à loja e estudar outras modalidades de pagamento para adquirir o equipamento pretendido.",
  "Request denied": "Pedido recusado",
  "We regret to inform you that we cannot give a favorable response to your request.":
    "Lamentamos informar que não foi possível dar continuidade ao seu pedido de locação.",
  Maintenance: "Manutenção",
  "The app is temporarily unavailable.": "A aplicação encontra-se temporáriamente indisponível",
  "Please come back later.": "Por favor volte mais tarde.",

  /* ========================================== */
  /* ORDER ================================== */
  /* ========================================== */
  "Contract start date": "Data de ínicio de contrato",
  "Contract end date": "Data de fim de contrato",
  "Contract renewal date": "Data de renouvação de contrato",
  "New Order": "Novo contrato",
  "Renew Order": "Renovar meu contrato",

  /* ========================================== */
  /* LOGIN ================================== */
  /* ========================================== */
  "Bad credentials": "O nome de utilizador ou a palavra passe estão incorrectos.",
  username: "Identificador",
  password: "Palavra passe",
  connect: "Aceder",
  "need help": "Precisa de ajuda?",
  "login page need help tooltip":
    "Contacte um operador evollis através do email support.fnacpt@evollis.com no período entre as 10:00 e 21:00 (Seg a Sex) e das 11:00 às 21:00 ( Sáb e Dom)",
  "User account is locked":
    "A sua conta encotra-se bloqueada. Por favor contacte o suporte para desbloquear a sua conta.",

  /* ========================================== */
  /* RESET PASSWORD  ========================== */
  /* ========================================== */
  password_expired: "password expirada",
  old_password: "Password anterior",
  new_password: "Nova password",
  verify_new_password: "Confirmação de nova password",
  change_password: "Mude a sua password",
  confirmation_password_matches_new_password: "A password de confirmação corresponde à anterior",
  old_password_matches_current_password: "A sua password actual não correponde à password inserida!",
  different_password: "Palavra passe diferente",

  /* ========================================== */
  /* RETAIL ================================== */
  /* ========================================== */
  TOUS: "Todos",
  WAIT_SIGNATURE: "A aguardar assinatura",
  WAITING_DOCUMENTS: "A aguardar documentos",
  REJECTED: "Recusado",
  PJ_UPLOADES: "Documentos carregados",
  ACCEPTED_AWAITING_FUNDING: "Aceite - a aguardar financiamento",
  NOT_FINALIZED: "Não finalizado",
  A_TRAITER_OCTROI: "Em análise",
  REFUSED_AFTER_DOCUMENT_ANALYSIS: "Recusado após análise de documentos",
  DEFAULT: "DEFAULT n/a",

  /* ========================================== */
  /* FOOTER ================================== */
  /* ========================================== */

  legalMention: "Menções legais",
  legalMentionTitle: "Link para as menções legais de BNP Paribas Leasing Solutions",
  privacyPolicy: "Politica de confidencialidade",
  privacyPolicyTitle: "Link para a politica de confidencialidade BNP Paribas Leasing Solutions",
  cookiesPolicy: "Politica de cookies",
  cookiesPolicyTitle: "Link para a politica de cookies BNP Paribas Leasing Solutions",
  /* ========================================== */
  /* PDI RETAIL ================================== */
  /* ========================================== */
  home_button_new: "Nova simulação",
  home_button_new_description: "Começar uma simulação",
  home_button_penalty_simulation: "Simulação de penalização",
  home_button_takeover: "As minhas simulações",
  home_button_takeover_description: "Recuperar uma simulação",
  home_button_renewal: "As minhas renovações",
  home_button_renewal_description: "Renovar un contrato elegível",
  home_button_continue_order: "Contrato em curso",
  home_button_continue_order_description: "Recuperar um contrato não finalizado",
  home_button_after_sales: "Pós-Venda",
  home_button_after_sales_description: "Gerir contratos, aceder a ferramentas",
  resume_order_load_search: "Pesquisa em curso...",
  resume_order_success_search: "Pesquisa terminada",
  resume_order_error_search: "Erro após pesquisa",
  resume_order_input_search_label: "Nome ou nº de contrato",
  resume_order_fill_shipping_date_button_label: "Introduza a data de entrega",
  shop: "Loja",
  search: "Procurar",
  save: "Guardar",
  identification_button_saveForLater: "Guardar a simulação",
  search_no_result: "Nenhum resultado",
  simulation_shop_block_title: "Escolha de loja",
  simulation_shop_input_label: "Seleccione uma loja",
  simulation_delivery_block_title: "Modo de entrega",
  simulation_delivery_input_label: "Seleccione um modo de disponibilização do produto",
  simulation_products_block_title: "Escolha do produto",
  simulation_family_input_label: "Família",
  simulation_category_input_label: "Categoria",
  simulation_price_input_label: "Preço PVP",
  simulation_quantity_input_label: "Quantidade",
  simulation_product_input_label: "Produto",
  simulation_button_create_product: "+ Inserir",
  simulation_brand_input_label: "Marca",
  simulation_description_input_label: "Descrição",
  simulation_button_add_product: "+ Adicionar um produto",

  simulation_promotion_block_title: "Promoción",
  simulation_promotion_input_label: "Código de promoción",
  simulation_promotion_button_label: "Aplicar",
  simulation_promotion_response_valid: {
    propsValues: (props) => {
      const { promotionCode } = props
      return `O seu código promocional  “${promotionCode}” foi aplicado.`
    }
  },
  simulation_promotion_response_invalid: "O seu código promocional não foi aplicado.",

  simulation_button_reset: "Reiniciar",
  simulation_button_update: "Actualizar a simulação",
  create_product_inprogress_toast: "Criação em curso...",
  create_product_success_toast: "Produto adicionado",
  create_product_error_toast: "Erro durante a criação do produto",
  create_product_title: "Criar um novo produto",
  numero_marquage: "Número de marcação",
  "En commande": "No Imediato",
  "A emporter": "No Imediato",
  "A emporter différé": "Mais tarde",
  "Invalid format": "Formato inválido",
  "Not a valid MM/YYYY date": "Insira uma data formato MM/AAAA",

  /* ========================================== */
  /* RETAIL ================================== */
  /* ========================================== */
  upload_file_title: "Carregar documentos",
  upload_line_label: "Página",
  upload_button_line: "Escolha um arquivo",
  upload_line_no_upload: "Nenhum arquivo selecionado",
  upload_button_add_document: "+ Adicionar um documento",
  wrongFileExtensionMessage: "Este arquivo não é compatível, você deve escolher uma imagem ou um pdf.",
  onlyAlphaNumericMessage: "O nome deve conter apenas caracteres alfanuméricos",
  upload_toast_success: "Importar novo documento com sucesso",
  upload_toast_fail: "Erro na importação de novo documento : ",
  imei: "IMEI",
  bill_number: "Número da fatura do produto",

  /* ========================================== */
  /* SIMULATION FINAL PAGE ==================== */
  /* ========================================== */
  simulation_final_page_title: "Simulação guardada",
  simulation_final_page_content: {
    propsValues: (props) => {
      const { simulationStorageTime } = props
      return (
        <>
          <p>A sua simulação foi guardada com sucesso.</p>
          <p>
            O cliente recebeu por mail a simulação com um link que lhe permitirá continuar o processo de pedido de
            locação.
          </p>
          <p>Atenção, o link só estará válido por {simulationStorageTime} dias.</p>
        </>
      )
    }
  },
  /* ========================================== */
  /* RESUME ORDER PAGE ==================== */
  /* ========================================== */
  start_by_searching_for: "Comece por efectuar uma pesquisa...",
  loading_orders: "A carregar ficheiros...",
  sort_by: "Ordenar por",
  newest: "Mais recente",
  oldest: "Mais antigo",
  filter_by: "Filtrar por",
  document_type: "Tipo de documento",
  remove_product: "Remover produto",

  retail_patch_order_success_label: "O seu número foi guardado com sucesso.",

  one_lower_case_required: "Ao menos um carácter minusculo",
  one_upper_case_required: "Ao menos um carácter maiusculo",
  one_number_required: "Au menos um número ou símbolo",
  more_than_height_length: "Ao menos 8 carácteres",
  previous: "Anterior",
  next: "Seguinte",
  change_identity_bloc_simplified_journey:
    "Se desejar alterar os dados presentes em “A minha identidade”, contacte o nosso serviço de apoio ao cliente através do seguinte endereço {adresse}",
  /* Algoan Bank Modal */
  algoanBankModal_loadingAria: "A carregar",
  algoanBankModal_loadingText: "A obter as suas contas bancárias...",
  algoanBankModal_errorMessage: "Ocorreu um erro. Por favor, tente novamente mais tarde.",
  algoanBankModal_retry: "Tentar novamente",
  algoanBankModal_titleSingle: "A conta bancária na qual serão debitadas as suas mensalidades.",
  algoanBankModal_titleMultiple: "Escolha a conta bancária na qual deseja que sejam debitadas as suas mensalidades.",
  algoanBankModal_continue: "Continuar",
  algoanBankModal_noAccount: "Não foi possível identificar nenhuma conta bancária em seu nome.",
  algoanBankModal_noAccountAdvice: "Faça um novo percurso e utilize uma conta bancária da qual seja titular.",
  /* Algoan Open Banking error codes */
  algoanBankModal_CURRENCY_NOT_SUPPORTED_title: "Moeda não suportada",
  algoanBankModal_CURRENCY_NOT_SUPPORTED_message:
    "Não podemos analisar a sua conta bancária porque a moeda da sua conta não é compatível com o nosso serviço. Utilize uma conta em euros.",
  algoanBankModal_NO_CHECKING_ACCOUNT_title: "Nenhuma conta à ordem detectada",
  algoanBankModal_NO_CHECKING_ACCOUNT_message:
    "Não detetámos nenhuma conta à ordem em seu nome. Utilize uma conta bancária à ordem para continuar o seu pedido.",
  algoanBankModal_ACCOUNT_TYPE_NOT_SUPPORTED_title: "Tipo de conta desconhecido",
  algoanBankModal_ACCOUNT_TYPE_NOT_SUPPORTED_message:
    "O tipo de conta bancária detetado não é compatível com a nossa análise. Utilize uma conta bancária clássica.",
  algoanBankModal_OWNERSHIP_NOT_SUPPORTED_title: "Cliente não titular (procuração)",
  algoanBankModal_OWNERSHIP_NOT_SUPPORTED_message:
    "A conta bancária utilizada não parece estar em seu nome. Utilize uma conta da qual seja titular.",
  algoanBankModal_USAGE_NOT_SUPPORTED_title: "Conta profissional",
  algoanBankModal_USAGE_NOT_SUPPORTED_message:
    "As contas profissionais não são aceites. Utilize uma conta bancária pessoal.",
  algoanBankModal_NOT_ENOUGH_TRANSACTIONS_title: "Transações insuficientes",
  algoanBankModal_NOT_ENOUGH_TRANSACTIONS_message:
    "Não dispomos de um histórico bancário suficiente para analisar a sua situação. Utilize uma conta com transações recentes.",
  algoanBankModal_UNKNOWN_title: "Caso não identificado",
  algoanBankModal_UNKNOWN_message: "Ocorreu um erro ao analisar a sua conta bancária. Tente novamente mais tarde.",

  /* FNAC PT — textos legais (idioma por defeito do tunnel) */
  fnac_pt_legal_mention_0:
    "Contrato de arrendamento de longa duração e serviços associados, sujeito à aceitação do processo pela Locadora Evollis, SAS com um capital de {shareCapitalFinancer} €. Sede : 22 -26 Quai de Bacalan, 33300 Bordéus.",
  fnac_pt_legal_mention_1: "RCS Bordeús n° 530 612 571 N°ADEME : FR320894 _03JPOV",
  fnac_pt_legal_mention_2:
    "Salvo indicação em contrário, as informações solicitadas são obrigatórias. Os dados recolhidos destinam-se à Evollis, responsável pelo tratamento de dados, e são usados para gerenciar a sua solicitação de um contrato de locaçãp, para nos permitir oferecer ofertas adequadas e para cumprir nossas obrigações legais e regulatórias. Para mais informações sobre o tratamento dos seus dados pessoais e para exercer os seus direitos: direito de acesso, retificação, eliminação, limitação do tratamento, portabilidade dos dados, direito de oposição (incluindo a utilização dos seus dados pessoais para fins de marketing direto) e o direito de organizar a gestão dos seus dados após a sua morte, pode consultar o artigo dedicado ao Aviso de Proteção de Dados Pessoais presente no seu contrato de aluguer ou contactar-nos através do seguinte endereço: Evollis - Serviço Cliente - 22 -26 Quai de Bacalan 33300 Bordéus ou por e-mail: protectiondonnees@evollis.com"
}
